import React, { useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
// AI chat assistant hidden for now

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // The app shell scrolls inside <main>, so the body must not scroll. Locking
  // body overflow here (not in CSS globally) keeps auth/public pages — which
  // scroll the body — unaffected, and stops Stripe's offscreen fixed iframes
  // from adding phantom scroll space below the footer.
  useEffect(() => {
    document.documentElement.classList.add("app-shell-locked");
    document.body.classList.add("app-shell-locked");
    return () => {
      document.documentElement.classList.remove("app-shell-locked");
      document.body.classList.remove("app-shell-locked");
    };
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-[#F9FAFB]" style={{ backgroundColor: "#f1f3f6" }}>
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col md:ml-[250px] h-screen">
        <Header />
        {/* main is the ONLY scroll container and is itself the flex column.
            The content area uses flex-1 (reliable, since main has a definite
            flex height) to push the footer to the bottom when content is short,
            and the footer flows right after content when it's tall — so there's
            never empty space below the footer. */}
        <main className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden flex flex-col">
          <div className="flex-1 p-6">{children}</div>
          <Footer />
        </main>
      </div>
      {/* AI chat assistant hidden for now */}
      {/* <button
        type="button"
        onClick={() => setIsAiOpen(true)}
        className="fixed -bottom-4 -right-4 z-50 cursor-pointer hover:scale-110 transition-transform m-3"
      >
        <img
          src={AiImg}
          alt="AI Assistant"
          className="w-32 h-32 object-contain drop-shadow-lg"
        />
      </button>
      <AiAssistantModal isOpen={isAiOpen} onClose={() => setIsAiOpen(false)} /> */}
    </div>
  );
};

export default MainLayout;
